import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DynamicFormComponent } from '../../../dynamic-form/dynamic-form.component';
import bankAccountFormConfig from "../config/bank-account-form.json"
import { DynamicForm } from '../../../../models/dynamic-form';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicFormService } from '../../../../services/dynamic-form.service';
import { BankAccount } from '../../../../models/masters/contact-information.interface';
import { FileUploadService } from '../../../../services/file-upload.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { SharedModule } from '../../../../modules/shared/shared.module';
import { FileEntity } from '../../../../models/common-model.interface';

@Component({
  selector: 'app-bank-account-form',
  standalone: true,
  imports: [DynamicFormComponent, FileUploadComponent, SharedModule],
  templateUrl: './bank-account-form.component.html',
  styleUrl: './bank-account-form.component.scss'
})
export class BankAccountFormComponent {
  
  @Input() bankAccount!: BankAccount;
  @Input() viewMode: boolean = false;
  @Output() onSave = new EventEmitter<BankAccount>();

  bankAccountForm!: FormGroup;
  bankAccountFormConfig!: DynamicForm;

  attachments: FileEntity[] = [];

  allowedFileTypes: string[] = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "text/pdf"
  ];

  constructor(private fb: FormBuilder,
    private dynamicFormService: DynamicFormService,
    private fileUploadService: FileUploadService
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.patchFormData(this.bankAccount);
  }

  private initForm(): void {
    this.bankAccountForm = this.fb.group({ifscCode: [null]});
    this.bankAccountFormConfig = bankAccountFormConfig;
    this.dynamicFormService.addControlsToForm(this.bankAccountForm, this.bankAccountFormConfig);
  }

  handleValueChange(event: {controlName: string, result: any}) {
    const { controlName, result } = event;
    console.log(event);
    if (controlName === 'bankId') {
      this.bankAccountForm.get('bankName')?.setValue(result?.name);
      this.bankAccountForm.get('branch')?.setValue(result?.branch);
    }
  }

  saveForm() {
    this.bankAccountForm.markAllAsTouched();
    if (!this.bankAccountForm.valid) return;
    const bankAccountData = this.getBankData();
    this.onSave.emit(bankAccountData);
  }

  getBankData(): BankAccount {
    const formValue = this.bankAccountForm.getRawValue();
    return {
      ...formValue,
      bankId: formValue.bankId.key,
      bankMetadata: {
        name: formValue.bankName,
        branch: formValue.branch,
        ifscCode: formValue.bankId.value
      },
      file: this.attachments[0],
      fileId: this.bankAccount?.fileId ? this.bankAccount.fileId : null,
      uploadedFile: this.bankAccount?.uploadedFile
    };
  }

  onFileChange(file: FileEntity[]) {
    if (this.bankAccount?.fileId) {
      delete this.bankAccount.fileId;
    }
  }

  patchFormData(account: BankAccount): void {
    if (!account) return;

    this.bankAccountForm.patchValue({
      ...account,
      bankId: {
        key: account.bankId,
        value: account.bankMetadata?.ifscCode || ''
      },
      bankName: account.bankMetadata?.name || '',
      branch: account.bankMetadata?.branch || ''
    });

    const uploadedFile = account?.file ? account.file : this.fileUploadService.convertToFileFromDTO(account?.uploadedFile);
    this.attachments = uploadedFile ? [uploadedFile] : [];

    if (this.viewMode) {
      this.bankAccountForm.disable();
    }
  }
}
